import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

const createVuetifyWithThemeColor = (primaryColor) => {
  return new Vuetify({
    theme: {
      themes: {
        light: {
          primary: primaryColor,
        },
        dark: {
          primary: primaryColor,
        },
      },
      icons: {
        iconfont: "md",
      },
    },
  });
};

export default createVuetifyWithThemeColor;
